import axios from 'axios'
import base from '../../../base'
import resource from './resource'
import { REQUEST_DATA_SUCCESS } from './mutation-types'

export default {
  requestData({ commit }, payload) {
    const { query, ...data } = payload
    const str = window.localStorage.getItem('imea.portal.instituicao')
    if (str) {
      const instituicao = JSON.parse(str)
      data.instituicao = instituicao.Id ? instituicao.Id : ''
    }
    data.nome = query
    data.all = 1
    data.sort = 1

    const config = {
      method: 'post',
      url: resource,
      baseURL: base,
      data
    }

    return axios(config).then(({ data }) => {
      commit(
        REQUEST_DATA_SUCCESS,
        data.map(({ Id, Descricao }) => {
          return { id: Id, text: Descricao, selected: false }
        })
      )
    })
  }
}
